import { render, staticRenderFns } from "./ConfirmationSms.vue?vue&type=template&id=5ee48a57"
import script from "./ConfirmationSms.vue?vue&type=script&lang=js"
export * from "./ConfirmationSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports